import React, { createContext } from 'react';
import { Toast, ToastTypes } from '../components/toast/Toast';
import { useLoader } from '../hooks/useLoader';
import { useToast } from '../hooks/useToast';
import { Loading } from '../components/Loading';

interface UIContextProps {
  loader: {
    showLoader: VoidFunction;
    hideLoader: VoidFunction;
  };
  toast: {
    showToast: (message: string, type?: ToastTypes) => void;
  };
}

export const UIContext = createContext<UIContextProps | null>(null);

interface Props {
  children?: React.ReactNode;
}

export const UIContextProvider: React.FC<Props> = ({ children }) => {
  const { showLoader, hideLoader, isLoaderVisible } = useLoader();
  const { showToast, isToastVisible, toastType, closeToast, toastMessage } = useToast();
  return (
    <UIContext.Provider value={{
      loader: {
        showLoader,
        hideLoader,
      },
      toast: {
        showToast,
      },
    }}
    >
      {children}
      {isLoaderVisible && <Loading isVisible={isLoaderVisible} />}
      {isToastVisible && <Toast onClose={closeToast} message={toastMessage} type={toastType} />}
    </UIContext.Provider>
  );
};

export const useUIContext = (): UIContextProps => {
  const context = React.useContext(UIContext);
  if (!context) {
    throw new Error('useUIContext must be used within a UIContextProvider');
  }
  return context;
};
